import { scheduleListActions } from '../actions'
import { groupScheduleByDate } from '../utils/groupScheduleByDate'
import { useActions, useAppSelector } from '../../../store/hooks'
import { exportSelector } from '../../../store/slices/export'
import { referencesSelector } from '../../../store/slices/references'
import { scheduleSelector } from '../../../store/slices/schedule'
import { schedulePageSelector } from '../../../store/slices/schedulePage'

export function useScheduleList() {
    const schedule = useAppSelector(scheduleSelector.items)
    const loadingSchedule = useAppSelector(scheduleSelector.isLoading)
    const totalItems = useAppSelector(scheduleSelector.total)
    const scheduleError = useAppSelector(scheduleSelector.error)
    const referencesError = useAppSelector(referencesSelector.error)
    const exportError = useAppSelector(exportSelector.error)
    const pageError = useAppSelector(schedulePageSelector.error)
    const viewMode = useAppSelector(schedulePageSelector.viewMode)
    const currentPage = useAppSelector(schedulePageSelector.currentPage)
    const pageSize = useAppSelector(schedulePageSelector.pageSize)

    const { setPagination } = useActions(scheduleListActions)

    const entries = groupScheduleByDate(schedule)

    const errorMessage = pageError || scheduleError || referencesError || exportError

    const changePage = (nextPage, nextSize) => {
        if (nextSize !== pageSize) {
            setPagination({ page: 1, pageSize: nextSize })
            return
        }

        setPagination({ page: nextPage })
    }

    const changePageSize = (current, nextSize) => {
        setPagination({ page: 1, pageSize: nextSize })
    }

    return {
        viewMode,
        entries,
        loadingSchedule,
        errorMessage,
        totalItems,
        currentPage,
        pageSize,
        changePage,
        changePageSize,
    }
}
